import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { Grid, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import FileUploader from "../../../TCPForms/reusableComponents/FileUploader";
import ButtonWrapper from "../../components/Button";
import { InfoBox, SummaryCard, CustomAccordionSummary } from "../../components/StyledComponent";
import { FaFilePdf } from "react-icons/fa";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import { bindActionCreators } from "redux";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import { Col, Container, Row } from "react-bootstrap";

const Step2 = ({ formData, handleTabChange, tenantId }) => {
  const dispatch = useDispatch();
  const { initFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const { documents } = useSelector((state) => state.formMT);
  const userInfo = Digit.UserService.getUser();
  const { t } = useTranslation();
  const isDA = formData?.department === "DA";
  const isLowRiskCase = formData?.riskType === "LOW";
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const defaultValues = {
    ...formData,
  };
  const isScheme = formData?.descriptionOfLand?.schemeType === "Scheme";
  const isSelfCert = formData?.planOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  const { handleSubmit, control, setValue, trigger } = useForm({ defaultValues });
  const fastPasData = Digit?.SessionStorage.get("FASTPAS_ID_DATA");
  const landUseDocs = fastPasData?.landUse?.documents || [];
  const mapSubDocs = fastPasData?.mapSubmission?.documents || [];

  const identifyLayoutCase = (data) => {
    if (
      data?.descriptionOfLand?.activityProposed === "Plotted Development" ||
      data?.descriptionOfLand?.activityProposed === "Plotted Development - Affordable"
    ) {
      return true;
    } else return false;
  };
  const isLayoutCase = identifyLayoutCase(formData);
  useEffect(() => {
    async function fetchLTPData() {
      const createdBy = userInfo?.info?.uuid;
      try {
        const response = await Digit.OBPSService.BPAREGSearch(tenantId, {}, { createdBy: createdBy });
        const ltpData = response?.Licenses?.filter((e) => e.status === "APPROVED") || [];
        console.log(response, ltpData, "ltpDataaaaaa");
        const regCert = ltpData?.[0]?.tradeLicenseDetail?.applicationDocuments?.filter((e) => e.documentType === "Registration Certificate") || [];

        // Deduplicate documents by fileStoreId to prevent duplicates
        const allDocs = [...regCert, ...documents, ...landUseDocs, ...mapSubDocs];
        const uniqueDocs = Array.from(new Map(allDocs.map((doc) => [doc.fileStoreId, doc])).values());

        initFormMTDocs(uniqueDocs);
      } catch (error) {
        console.error("Error fetching migrated data:", error);
      }
    }
    fetchLTPData();
  }, []);

  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  const onSubmit = (data) => {
    data = {
      ...data,
      nocDetails: formData?.nocDetails,
    };
    console.log("dataFromDocComponent", data);

    handleTabChange(2, data);
  };
  return (
    <section className="groupContainer">
      <form onSubmit={handleSubmit(onSubmit)}>
        {/* {formData?.edcrNumber && (
          <div className="formContainer">
            <div className="formHeaderContainer">
              <InfoBox>
                Please download the <strong>Drawing</strong>, add your <strong>Digital Signature</strong> and then upload the signed file to the
                Drawing PDF File Section <span className="mandatory">*</span>.
              </InfoBox>
            </div>
          </div>
        )} */}
        {formData?.edcrNumber && (
          <SummaryCard className="formContainer">
            <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ width: "100%" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", padding: "2rem" }}>
                  <Grid item xs={12} md={6}>
                    {" "}
                    {/* Two items per row on medium screens and above */}
                    <Grid container spacing={2} style={{ padding: "1rem" }}>
                      <Grid item xs={6}>
                        <strong>{"Drawing Pdf"} </strong>:
                      </Grid>{" "}
                      {/* Label part */}
                      <Grid item xs={6}>
                        <FaFilePdf
                          color="#a10505"
                          style={{ width: "20px", height: "30px" }}
                          onClick={() => window.open(formData?.updatedDxfFile, "_blank")}
                        />
                      </Grid>
                      {/* <Grid item xs={6}><strong>{'Plan Report'} </strong>:</Grid>
                                        <Grid item xs={6}>
                                            <FaFilePdf
                                                color="#a10505"
                                                style={{ width: '20px', height: '30px' }}
                                                onClick={() => window.open(formData?.planReport, '_blank')}
                                            />
                                        </Grid>
                                        <Grid item xs={6}><strong>{'.dxf File'} </strong>:</Grid>
                                        <Grid item xs={6}>
                                            <FaFilePdf
                                                color="#a10505"
                                                style={{ width: '20px', height: '30px' }}
                                                onClick={() => window.open(formData?.dxfFile, '_blank')}
                                            />
                                        </Grid> */}
                    </Grid>
                  </Grid>
                </table>
              </div>
            </div>
          </SummaryCard>
        )}

        {/* {   <div className="formContainer">
          <div className="formHeaderContainer card-stript">
            <InfoBox>Sample Affidavit</InfoBox>
          </div>
        </div>} */}
        {/* <SummaryCard className="formContainer affidavit-box">
          <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ width: "100%" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", padding: "2rem" }}>
                <Grid item xs={12} md={6}>
                  {" "}
                  {/* Two items per row on medium screens and above */}
        {/* <Grid container spacing={2} style={{ padding: "1rem" }}> */}
        {/* <Grid item xs={6}> */}
        {/* <strong>{"Affidavit Pdf"} </strong>: */}
        {/* </Grid> */}
        {/* Label part */}
        {/* <Grid item xs={6}>
                      <FaFilePdf
                        color="#a10505"
                        style={{ width: "20px", height: "30px" }}
                        onClick={() => getDocumentByFileStoreId("9db90601-fd5e-416a-8fe9-cac1eec638d1", setIsPreviewLoading)}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </table>
            </div>
          </div>
        </SummaryCard>  */}
        {formData?.natureOfConstruction === "Compounding" && (
          <div className="formContainer">
            <div className="formHeaderContainer">
              <h2 className="formHeading">{t("Compounding Documents")}</h2>
            </div>

            <div className="formInputContainer common-app-form Upload-Input2 d-block only-white-bg">
              <div className="columnWrapper">
                {formData?.shortName === "yes" && (
                  <React.Fragment>
                    {" "}
                    <Row className="inner-mini-wrapper">
                      <Col md={6}>
                        <FileUploader
                          label={t("Sanction Map")}
                          control={control}
                          name="Sanction Map"
                          validationMsg="Upload File"
                          required
                          isMandatory
                          trigger={trigger}
                        />
                      </Col>
                    </Row>
                    <Col md={6}>
                      <FileUploader
                        label={t("Sanction Letter")}
                        control={control}
                        name="Sanction Letter"
                        validationMsg="Upload File"
                        required
                        isMandatory
                        trigger={trigger}
                      />
                    </Col>
                    <Col md={12}>
                      <div class="text-red important-note">Note: (pdf file only and Max file Size 30 MB)*</div>
                    </Col>
                  </React.Fragment>
                )}
                <Row className="inner-mini-wrapper">
                  <Col md={6}>
                    <FileUploader
                      isMandatory
                      label={t("Compounding Drawing PDF")}
                      control={control}
                      name="compoundingDrawingPdf"
                      validationMsg="Upload File"
                      required
                      trigger={trigger}
                    />
                  </Col>
                  <Col md={6}>
                    <FileUploader
                      isMandatory
                      label={t("Compounding drawing dwg")}
                      control={control}
                      name="compoundingDrawingDxf"
                      validationMsg="Upload File"
                      required
                      tab={3}
                      trigger={trigger}
                    />
                  </Col>
                  {formData?.isAncestralProperty === "In response to notice" && (
                    <Col md={6}>
                      <FileUploader
                        isMandatory
                        label={t("Upload Notice")}
                        control={control}
                        name="responseNotice"
                        validationMsg="Upload File"
                        required
                        trigger={trigger}
                      />
                    </Col>
                  )}

                  {isSelfCert && (
                    <Col md={6}>
                      <FileUploader
                        isMandatory
                        label={t("Owner Affidavit")}
                        control={control}
                        name="ltpAffidavit"
                        validationMsg="Upload File"
                        required
                        trigger={trigger}
                      />
                    </Col>
                  )}

                  <Col md={6}>
                    <FileUploader
                      isMandatory
                      label={t("Site Photo")}
                      control={control}
                      name="uptodatePaymentLetter"
                      validationMsg="Upload File"
                      required
                      trigger={trigger}
                    />
                  </Col>
                  <div class="text-red important-note">Note: (pdf file only and Max file Size 30 MB)*</div>
                </Row>
              </div>
            </div>
          </div>
        )}
        <Accordion defaultExpanded>
          <CustomAccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="formHeaderContainer">
              <h2 className="formHeading">{t("Mandatory Documents")}</h2>
            </div>
          </CustomAccordionSummary>
          <AccordionDetails>
            <div className="formInputContainer common-app-form Upload-Input2 d-block only-white-bg">
              <div className="columnWrapper">
                <Row className="inner-mini-wrapper">
                  <Col md={6}>
                    <FileUploader
                      label={t("Architect/Engineer Registration Certificate")}
                      control={control}
                      name="Registration Certificate"
                      validationMsg="Upload File"
                      required
                      isMandatory
                      maxFiles={1}
                      trigger={trigger}
                    />
                  </Col>

                  {!isLowRiskCase && (
                    <Col md={6}>
                      <FileUploader
                        isMandatory
                        label={t("Calculation sheet of Estimate with Affidavit")}
                        control={control}
                        name="calculationSheet"
                        validationMsg="Upload File"
                        required
                        trigger={trigger}
                      />
                    </Col>
                  )}
                  {/* {!isLowRiskCase && (
                    <Col md={6}>
                      <FileUploader
                        isMandatory
                        label={t("Drawing PDF")}
                        control={control}
                        name="drawingPdf"
                        validationMsg="Upload File"
                        required
                        trigger={trigger}
                      />
                    </Col>
                  )} */}
                  {!isScheme && (
                    <Col md={6}>
                      <FileUploader
                        isMandatory
                        label={t("Khatauni")}
                        control={control}
                        name="khatauni"
                        validationMsg="Upload File"
                        required
                        trigger={trigger}
                      />
                    </Col>
                  )}

                  {!isSelfCert && (
                    <Col md={6}>
                      <FileUploader
                        isMandatory
                        label={t("Owner Affidavit")}
                        control={control}
                        name="ownerAffidavit"
                        validationMsg="Upload File"
                        required
                        trigger={trigger}
                      />
                    </Col>
                  )}
                  {isSelfCert && (
                    <Col md={6}>
                      <FileUploader
                        isMandatory
                        label={t("Drawing Pdf")}
                        control={control}
                        name="drawingPDF"
                        validationMsg="Upload File"
                        required
                        trigger={trigger}
                      />
                    </Col>
                  )}

                  {isScheme && (
                    <Col md={6}>
                      <FileUploader
                        isMandatory
                        control={control}
                        label={t("Allotment Letter/Possession Letter")}
                        name="allotmentLetterPossessionLetter"
                        validationMsg="Upload File"
                        required
                        maxFiles={4}
                        trigger={trigger}
                      />
                    </Col>
                  )}
                  <Col md={6}>
                    <FileUploader
                      label={t("Registry Deed/up to date payment certificate from property section/Hire Purchase Tentant/Agreement")}
                      control={control}
                      name="registrySaleDeedHPTA"
                      isMandatory
                      validationMsg="Upload File"
                      required
                      trigger={trigger}
                    />
                  </Col>
                  {/* {isScheme && <FileUploader
                                isMandatory
                                label={t("Possession Letter")}
                                control={control}
                                name="possessionLetter"
                                validationMsg="(pdf file only and Max file Size 30 MB)"
                                required
                            />} */}
                  {isSelfCert && (
                    <Col md={6}>
                      <FileUploader
                        isMandatory
                        label={t("LTP Affidavit")}
                        control={control}
                        name="ltpAffidavit"
                        validationMsg="Upload File"
                        required
                        trigger={trigger}
                      />
                    </Col>
                  )}

                  {!isScheme && (
                    <Col md={6}>
                      <FileUploader
                        // isMandatory
                        label={t("Developer/Consortium/Sales Agreement")}
                        control={control}
                        name="developerConsortiumSalesAgreement"
                        validationMsg="Upload File"
                        // required
                        trigger={trigger}
                      />
                    </Col>
                  )}
                  {!isDA && (
                    <Col md={6}>
                      <FileUploader
                        isMandatory
                        label={t("Upto date payment letter")}
                        control={control}
                        name="uptodatePaymentLetter"
                        validationMsg="Upload File"
                        required
                        trigger={trigger}
                      />
                    </Col>
                  )}
                  {isLayoutCase && (
                    <Col md={6}>
                      <FileUploader
                        isMandatory
                        label={t("Revised map")}
                        control={control}
                        name="revisedMap"
                        validationMsg="Upload File"
                        required
                        trigger={trigger}
                      />
                    </Col>
                  )}
                  <Col md={12}>
                    <div class="text-red important-note">Note: (pdf file only and Max file Size 30 MB)*</div>
                  </Col>
                </Row>

                <Row className="inner-mini-wrapper">
                  <Col md={6}>
                    <FileUploader
                      isMandatory
                      label={t("Site Photo")}
                      control={control}
                      name="sitePhoto"
                      validationMsg="Upload File"
                      required
                      maxFiles={4}
                      tab={2}
                      trigger={trigger}
                    />
                  </Col>
                  <Col md={12}>
                    <div className="text-red important-note">Note: (jpg, jpeg, png file only and Max file Size 10 MB)*</div>
                  </Col>
                </Row>

                {/* <FileUploader
                                isMandatory
                                label={t("Common Affidavit")}
                                control={control}
                                name="commonAffidavit"
                                validationMsg="(pdf file only and Max file Size 30 MB)"
                                required
                            /> */}

                {/* <FileUploader
                                isMandatory
                                label={t("Owner Affidavit")}
                                control={control}
                                name="ownerAffidavit"
                                validationMsg="(pdf file only and Max file Size 30 MB)"
                                required
                            /> */}

                {/* {!isScheme && <FileUploader
                                isMandatory
                                label={t("Mutation Letter")}
                                control={control}
                                name="mutationLetter"
                                validationMsg="(pdf file only and Max file Size 30 MB)"
                                required
                            />} */}
              </div>
            </div>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <CustomAccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="formHeaderContainer">
              <h2 className="formHeading">{t("Conditional Documents")}</h2>
            </div>
          </CustomAccordionSummary>
          <AccordionDetails>
            <div className="formInputContainer common-app-form Upload-Input2 d-block only-white-bg">
              <div className="columnWrapper">
                <Row className="inner-mini-wrapper">
                  <Col md={6}>
                    <FileUploader label={t("Structural Audit Report")} control={control} name="structuralAuditReport" validationMsg="Upload File" />
                  </Col>

                  <Col md={6}>
                    <FileUploader label={t("Additional Document if any")} control={control} name="additionalDoc" validationMsg="Upload File" />
                  </Col>

                  <Col md={6}>
                    <FileUploader
                      label={t("Structural Drawing and Design ")}
                      control={control}
                      name="structuraldrawing"
                      validationMsg="Upload File"
                    />
                  </Col>

                  <Col md={6}>
                    <FileUploader
                      label={t("Structural Stability Certificate")}
                      control={control}
                      name="structuralcertificate"
                      validationMsg="Upload File"
                    />
                  </Col>

                  <Col md={6}>
                    <FileUploader
                      label={t("Structural Design calculation Report")}
                      control={control}
                      name="calculationReport"
                      validationMsg="Upload File"
                    />
                  </Col>
                  <Col md={6}>
                    <FileUploader
                      control={control}
                      label={t("Vetted Structure and drawing along with certificate")}
                      name="vettedStructure"
                      validationMsg="Upload File"
                    />
                  </Col>

                  <Col md={6}>
                    <FileUploader
                      label={t("Annexture 7, 8, 9, 10 duly signed by Owner, Architect and Structure Engineer.")}
                      control={control}
                      name="annexture789"
                      validationMsg="Upload File"
                    />
                  </Col>
                  {isDA && (
                    <Col md={6}>
                      <FileUploader
                        label={t("Upto date payment letter")}
                        control={control}
                        name="uptodatePaymentLetter"
                        validationMsg="Upload File"
                      />
                    </Col>
                  )}
                  <Col md={12}>
                    <div class="text-red important-note">Note: (pdf file only and Max file Size 30 MB)*</div>
                  </Col>
                </Row>
                <Row className="inner-mini-wrapper">
                  <Col md={6}>
                    <FileUploader
                      label={t("Approved Layout sanctioned Letter")}
                      control={control}
                      name="sanctionLetter"
                      validationMsg="Upload File"
                    />
                  </Col>

                  <Col md={12}>
                    <div className="text-red important-note">Note: (Allowed Format .pdf)*</div>
                  </Col>
                </Row>
              </div>
            </div>
          </AccordionDetails>
        </Accordion>

        <div className="footerContainer">
          <div className="buttonWrapper">
            <ButtonWrapper
              variant="contained"
              color="error"
              size="medium"
              label="Prev"
              sx={{ backgroundColor: "#CCC" }}
              onClick={() => handleTabChange(0)}
            />
            <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
          </div>
        </div>
      </form>
    </section>
  );
};

export default Step2;
